<template>
  <div class="share">
    <div class="header">
      <BaseText11
        class="text"
        text="Share with<br>your friends"
      />
      <div class="social">
        <BaseButtonShareFacebook :url="$content.shareUrl" :quote="quote"/>
        <BaseButtonShareTwitter :url="$content.shareUrl" :quote="quote"/>
        <BaseButtonDownload :url="userShareImageLocal"/>
      </div>
    </div>
    <div class="main">
      <img class="image" :src="userShareImageLocal">
      <router-link class="action-container" :to="{ name: 'selection', params: { initialSlide: nextOpponentIndex } }">
        <BaseButtonOctagon
          class="button"
          :text="userWonGame ? 'Next' : 'Play<br>Again'"
        />
      </router-link>
    </div>
    <div class="footer">
      <a :href="$content.buyUrl" target="_blank">
        <BaseButtonBuy class="buy-button"/>
      </a>
    </div>
    <img class="background" ref="background" :src="userShareImageLocal">
    <div class="background-overlay"/>
  </div>
</template>

<script>
import BaseButtonShareFacebook from '@/components/BaseButtonShareFacebook/BaseButtonShareFacebook'
import BaseButtonShareTwitter from '@/components/BaseButtonShareTwitter/BaseButtonShareTwitter'
import BaseButtonDownload from '@/components/BaseButtonDownload/BaseButtonDownload'
import BaseButtonOctagon from '@/components/BaseButtonOctagon/BaseButtonOctagon'
import BaseButtonBuy from '@/components/BaseButtonBuy/BaseButtonBuy'
import BaseText11 from '@/components/BaseText11/BaseText11'
import { opponentIds } from '@/data/opponents'
import { mapState, mapGetters } from 'vuex'
export default {
  name: 'share',
  components: {
    BaseButtonShareFacebook,
    BaseButtonShareTwitter,
    BaseButtonDownload,
    BaseButtonOctagon,
    BaseButtonBuy,
    BaseText11
  },
  computed: {
    currentOpponentIndex () {
      return opponentIds.indexOf(this.opponent.id)
    },
    isLastOpponent () {
      return this.currentOpponentIndex === opponentIds.length - 1
    },
    nextOpponentIndex () {
      if (this.userWonGame) return this.currentOpponentIndex + 1
      else return this.currentOpponentIndex
    },
    ...mapState('gameplay', [
      'userShareImageLocal'
    ]),
    ...mapGetters('gameplay', [
      'userWonGame',
      'opponent'
    ]),
    quote () {
      return this.opponent.id === 'KHABIB_NURMAGOMEDOV' && this.userWonGame
        ? `I brought my game face against ${this.opponent.name} in the UFC Ultimate Staredown and won! Bring on UFC 244.`
        : `I went face to face against ${this.opponent.name} in UFC Ultimate Staredown. See if you have what it takes!`
    }
  }
}
</script>

<style lang="scss" scoped>
.share {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}
.header,
.main,
.footer {
  z-index: 1;
}
.header {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
}
.text {
  margin-bottom: 2rem;
}
.social {
  display: flex;
  > *:not(:last-child) {
    margin-right: 1rem;
  }
}
.main {
  position: relative;
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 100%;
  padding: 0 2rem;
}
.image {
  width: 100%;
  height: auto;
  max-width: 100%;
}
.button {
  margin-top: -1rem;
}
.footer {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
}
.buy-button {
  width: 16rem;
  z-index: 1;
}
.background-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 0;
}
.background {
  position: absolute;
  top: 50%;
  left: 50%;
  min-height: 220%;
  min-width: 100%;
  transform: translate(-50%, -50%);
  z-index: 0;
}
</style>
